module.exports = __webpack_public_path__ + "static/esgResources-14d417dc2439184842cf2a892768d8d0.jpg";